import {fire} from "../../fire";
import {and, collection, or, query, where} from "firebase/firestore";
import {obtenerColeccionQuery} from "../../Servicios/BD/obtenerColeccionQuery";
import {COLECCIONRESERVAS, ESTADOSRESERVAS, FECHACHECKIN, FECHACHECKOUT} from "../Constantes";

export const obtenerReservacionesEntreFechasOcupacion = async ({fechaInicio, fechaFin}) => {


    let col = collection(fire, COLECCIONRESERVAS)
    let q = query(col, and(where('estado', 'in', [ESTADOSRESERVAS[0], ESTADOSRESERVAS[1], ESTADOSRESERVAS[2], ESTADOSRESERVAS[3], ESTADOSRESERVAS[4]]), where(FECHACHECKIN, '<=', fechaFin),
            or(where(FECHACHECKIN, '>=', fechaInicio),
                where(FECHACHECKOUT, '>=', fechaInicio))
        )
    )

    let dox = await obtenerColeccionQuery(q)


    return dox.data

}